<template>
    <v-container class="overflow-container" >
        <v-col cols="12">
            <v-row>
                <strong>Disponibilidad Docente</strong>
                <v-spacer></v-spacer>
                <v-btn color="success" x-small @click="dgDisponibilidad = true">Agregar</v-btn>
            </v-row>
            <v-simple-table dense v-if="detalle">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Dia</th>
                            <th class="text-left">Horario</th>
                            <th class="text-left">Modalidad</th>
                            <th class="text-left">Estado</th>
                            <th class="text-left" v-if="acciones">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in detalle.Disponibilidad" :key="index">
                            <td>{{ item.dia }}</td>
                            <td>{{ item.hora }}</td>
                            <td>{{ item.Modalidad }}</td>
                            <td >
                                <v-chip :color="item.Libre ? 'blue' : 'orange'" dark x-small outlined>
                                    {{ item.Libre ? "Libre" : "Ocupado" }}
                                </v-chip>
                            </td>
                            <td v-if="acciones">
                                <v-chip :color="item.Libre ? 'blue' : 'orange'" dark x-small outlined
                                    @click.stop="planificarAqui(item.disponibilidadId)" :loading="loadingDispo">
                                    {{ item.Libre ? "Planificar aquí!" : "Replanificar" }}
                                </v-chip>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
        <v-dialog v-model="dgDisponibilidad" scrollable max-width="500px" transition="dialog-transition">
            <v-card>
                <v-card-title>Cargar disponibilidad</v-card-title>
                <v-card-text>
                    <VDisponibilidad ref="dispo"></VDisponibilidad>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" text @click="dgDisponibilidad = false">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="cargarDisponibilidad" :loading="loadingDispo">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import Planificador from "../../services/Planificador.service";
import VDisponibilidad from "../../components/planificacdor/Disponifilidad.vue"
export default {
    components: {
        VDisponibilidad,
    },
    props: {
        acciones: {
            default: false,
        },
        detalle: {
            default:null,
        }
        
    },
    data() {
        return {
            dgDisponibilidad: false,
            loadingDispo: false,
        }
    },
    methods: {
        async cargarDisponibilidad() {
            if (!this.$refs.dispo.dia || !this.$refs.dispo.horario || this.$refs.modalidad) {
                return;
            }
            this.loadingDispo = true;
            let dia = { ...this.$refs.dispo.dia };
            dia.horario = this.$refs.dispo.horario;
            dia.docenteId = this.detalle.DocenteId;
            dia.modalidad = this.$refs.dispo.modalidad.modalidad;
            let disponibilidad = dia;
            Planificador.AgregarDisponibilidad(disponibilidad).then(
                res => {
                    this.loadingDispo = false;
                    this.$refs.dispo.dia = null;
                    this.$refs.dispo.horario = null;
                    this.$refs.dispo.modalidad = null;
                    this.detalle.Disponibilidad = res.data;
                    this.$toast.success("Registro cargado.");
                    this.$emit('notify', true);
                }).catch(err => {
                    this.loadingDispo = false;
                    this.$toast.error(err.response.data);
                });
        },
    },
}
</script>
<style lang="">

</style>